(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("missingRequiredRegistrationFields", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/missingRequiredRegistrationFieldsView.html",
            controller: ["authService", "calendarSettingsService", "myAccountResource", "tenantResource", "globalizationService", "messageService", "$state", "$translate", "$scope", "$timeout", "_", MissingRequiredRegistrationFieldsCtrl],
            controllerAs: "vm"
        };
        function MissingRequiredRegistrationFieldsCtrl(authService, calendarSettingsService, myAccountResource, tenantResource, globalizationService, messageService, $state, $translate, $scope, $timeout, _) {
            var vm = this;
            vm.showErrors = true;
            vm.saving = false;
            vm.loading = true;
            //vm.orgIsReadOnly = _.includes(authService.authentication.roles, "Organization Admin");
            myAccountResource.getMissingRequiredRegistrationFieldsViewModel(function (data) {
                vm.profileRecord = data.enabledRegistrationFields;
                //vm.userCanAddOrganization = data.userCanAddOrganization;
                vm.model = {
                    gender: vm.profileRecord.gender ? vm.profileRecord.gender.value : null,
                    birthdate: vm.profileRecord.birthdate ? vm.profileRecord.birthdate.value ? new Date(vm.profileRecord.birthdate.value) : null : null,
                    phoneNumber1: vm.profileRecord.phone1 ? vm.profileRecord.phone1.value : null,
                    phoneNumber2: vm.profileRecord.phone2 ? vm.profileRecord.phone2.value : null,
                    faxNumber: vm.profileRecord.fax ? vm.profileRecord.fax.value : null,
                    //organizationName: vm.profileRecord.organizationName ? vm.profileRecord.organizationName.value : null,
                    //organizationId: data.organizationId,
                    customQuestions: {}
                };
                vm.customQuestions = data.customQuestions;
                vm.phoneNumberMask = vm.profileRecord.phoneMask;
                vm.faxNumberMask = vm.profileRecord.faxMask;
                _.each(vm.customQuestions, function (question) {
                    if (question.answer !== "") {
                        if (question.typeId === 1)
                            vm.model.customQuestions[question.id] = parseInt(question.answer);
                        else if (question.typeId === 2) {
                            if (question.answer)
                                vm.model.customQuestions[question.id] = new Date(question.answer);
                        }
                        else
                            vm.model.customQuestions[question.id] = question.answer;
                    }
                    else
                        vm.model.customQuestions[question.id] = "";
                });
                if (vm.profileRecord.billingInformation) {
                    var billingInfo = vm.profileRecord.billingInformation.value;
                    vm.model.addressLine1 = billingInfo ? billingInfo.addressLine1 : "";
                    vm.model.addressLine2 = billingInfo ? billingInfo.addressLine2 : "";
                    vm.model.city = billingInfo ? billingInfo.city : "";
                    vm.model.postalCode = billingInfo ? billingInfo.zipPostalCode : "";
                    vm.model.provinceId = billingInfo ? billingInfo.stateProvinceId : null;
                    vm.model.countryId = billingInfo ? billingInfo.countryId : null;
                    tenantResource.getCountriesList(function (countryData) {
                        vm.countryList = countryData.countries;
                        vm.updateProvinceList(true);
                        vm.loading = false;
                    }, function (error) {
                        messageService.error(error);
                    });
                }
                else
                    vm.loading = false;
                vm.thereIsSomePersonalInfo = vm.profileRecord.gender ||
                    vm.profileRecord.birthdate ||
                    vm.profileRecord.phone1 ||
                    vm.profileRecord.phone2 ||
                    vm.profileRecord.fax ||
                    vm.customQuestions.length > 0;
            }, function (error) {
                messageService.error(error);
            });
            //Date picker config
            vm.format = "yyyy-MM-dd";
            calendarSettingsService.calendarSetup($scope);
            vm.open = calendarSettingsService.open;
            //Future Date Validation
            vm.checkDate = calendarSettingsService.checkDate;
            vm.updateProvinceList = function (firstLoad) {
                var countryObj = _.find(vm.countryList, { id: vm.model.countryId });
                if (countryObj) {
                    globalizationService.load(countryObj.threeLetterISOCode, function (result) {
                        vm.stateProvinceLabel = result.stateProvinceLabel;
                        vm.postalZipLabel = result.postalZipLabel;
                        vm.postalZipRegex = new RegExp(result.postalZipRegex);
                        vm.postalZipPattern = result.postalZipPattern;
                        vm.postalZipMask = result.postalZipMask;
                        vm.phoneNumberMask = result.phoneNumberMask;
                        vm.faxNumberMask = result.faxNumberMask;
                    });
                    vm.provinceList = countryObj.provinces;
                }
                else {
                    //if the country is cleared, clear the phone mask
                    vm.phoneNumberMask = null;
                    vm.faxNumberMask = null;
                }
                if (!firstLoad || vm.model.provinceId === 0) {
                    vm.model.provinceId = null;
                }
            };
            vm.translateName = function (name, isCountry) {
                if (isCountry)
                    return $translate.instant("common.country." + name.replace(/\s+/g, ""));
                return $translate.instant("common.stateProvince." + name.replace(/\s+/g, ""));
            };
            //vm.onSelect = function (item) {
            //	vm.model.organizationName = item.name;
            //	vm.model.organizationId = item.id;
            //};
            //vm.organizationChanged = function () {
            //	vm.model.organizationId = null;
            //};
            vm.save = function () {
                if (vm.saving)
                    return;
                vm.saving = true;
                $timeout(function () {
                    if (vm.form.$valid) {
                        vm.model.postalCode = vm.model.countryId ? vm.model.postalCode : null;
                        vm.model.provinceId = vm.model.provinceId ? vm.model.provinceId : 0;
                        vm.model.countryId = vm.model.countryId ? vm.model.countryId : 0;
                        myAccountResource.updateMissingRequiredRegistrationFields(vm.model, function () {
                            messageService.success("account.missingRegistrationData.success");
                            authService.authentication.isMissingRegistrationData = false;
                            authService.saveAuthenticationDataToLocalStorage();
                            if ($state.params.stateName)
                                $state.go($state.params.stateName, $state.params.stateParameters);
                            vm.saving = false;
                        }, function (error) {
                            messageService.error(error);
                            vm.saving = false;
                        });
                    }
                    else {
                        vm.showErrors = true;
                        vm.saving = false;
                    }
                }, 210);
            };
        }
    });
}());
